import { combineReducers } from 'redux';
import rbi from './rbi';
import partialRefund from './partialRefund';
import previousRefunds from './previousRefunds';
import checkOrderDate from './checkOrderDate';
import fetchOrder from './fetchOrder';
import selectedPartnerTrees from './selectedPartnerTrees';

export default combineReducers({
  rbi, // TODO: Put this inside partner data reducer
  selectedPartnerTrees,
  partialRefund,
  checkOrderDate,
  previousRefunds,
  fetchOrder,
});
